import {currentLocationIs} from '../helpers';
import {sendGaFromConfig} from '../tracking/utils';

function sendLoggedInEvent(loggedInEvent) {
    const isJson = loggedInEvent.charAt(0) === '{' ? true : false;

    // testing if event given is an object or a string
    if (!isJson) {
        Hop.events.trigger(loggedInEvent);
    } else {
        // if event given is an object with type and args , apply this event by joining type and args together
        const {type, args} = JSON.parse(loggedInEvent);
        const eventSettings = [type].concat(args);

        Hop.events.trigger(...eventSettings);
    }
}

export function extractRedirectUrl($tag) {
    const redirect = $tag.attr('data-redirect');
    if (!redirect) {
        return null;
    }

    const redirectParameters = $tag.attr('data-redirect-parameters');
    if (redirectParameters) {
        return redirect + '?' + redirectParameters;
    }

    return redirect;
}

export function redirectOrSendEventIfRequired($tag, hasFreelanceIdentity, hasCustomerIdentity, refreshIfNoRedirect) {
    if (!$tag) {
        return;
    }

    const loggedInEvent = $tag.attr('data-send-event-when-logged-in');
    if (loggedInEvent) {
        sendLoggedInEvent(loggedInEvent);
        return;
    }

    const redirect = extractRedirectUrl($tag);
    if (redirect) {
        window.location = redirect;
        return;
    }

    const href = $tag.attr('href');
    if (href && href !== '#') {
        // dans le cas d'un lien, on le suit tout simplement
        window.location = href;
        return;
    }

    // ???
    if ($tag.is('form') && $tag.data('hop-can-submit') === true) {
        // since this code is not well encapsulated, let's use jQuery.data()
        $tag.data('hop-connected', true);

        const additionalGaOnSubmit = $tag.attr('data-additional-ga-on-submit');
        if (additionalGaOnSubmit) {
            sendGaFromConfig(additionalGaOnSubmit);
        }

        $tag.submit();
        return;
    }

    // Redirect freelance users if signin is done on homepage
    if (hasFreelanceIdentity && currentLocationIs('/')) {
        redirectFreelancer();
        return;
    }
    // Redirect customer users on their dashboard if signin is done on homepage
    if (hasCustomerIdentity && currentLocationIs('/') && !window.alternativeNavbar) {
        window.location = '/dashboard';
        return;
    }

    if (refreshIfNoRedirect) {
        window.location.reload();
    }
}

function redirectFreelancer() {
    Hop.get('api/profile/availability')
        .then((response) => response.json())
        .then((availability) => {
            if (availability.notModifiedForAWhile && window.features.redirectOnLogin) {
                window.location = '/profile#edit-availability';
                return;
            }
            window.location = '/dashboard';
        });
}
